import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreVert = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_15_7897",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_15_7897)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.99546 15.391C9.6963 15.391 9.44171 15.2845 9.23171 15.0714C9.02157 14.8584 8.9165 14.6024 8.9165 14.3033C8.9165 14.0042 9.02303 13.7495 9.23609 13.5394C9.44914 13.3294 9.70518 13.2244 10.0042 13.2244C10.3034 13.2244 10.558 13.3309 10.768 13.5439C10.9781 13.7569 11.0832 14.0129 11.0832 14.3121C11.0832 14.6112 10.9766 14.8658 10.7636 15.0758C10.5505 15.286 10.2945 15.391 9.99546 15.391ZM9.99546 11.0833C9.6963 11.0833 9.44171 10.9768 9.23171 10.7637C9.02157 10.5507 8.9165 10.2946 8.9165 9.99562C8.9165 9.69645 9.02303 9.44186 9.23609 9.23186C9.44914 9.02173 9.70518 8.91666 10.0042 8.91666C10.3034 8.91666 10.558 9.02318 10.768 9.23624C10.9781 9.4493 11.0832 9.70534 11.0832 10.0044C11.0832 10.3035 10.9766 10.5581 10.7636 10.7681C10.5505 10.9783 10.2945 11.0833 9.99546 11.0833ZM9.99546 6.77561C9.6963 6.77561 9.44171 6.66909 9.23171 6.45603C9.02157 6.24312 8.9165 5.98707 8.9165 5.68791C8.9165 5.38874 9.02303 5.13416 9.23609 4.92416C9.44914 4.71402 9.70518 4.60895 10.0042 4.60895C10.3034 4.60895 10.558 4.71548 10.768 4.92853C10.9781 5.14159 11.0832 5.39763 11.0832 5.69666C11.0832 5.99582 10.9766 6.25048 10.7636 6.46061C10.5505 6.67061 10.2945 6.77561 9.99546 6.77561Z",
			fill: "#152A58"
		})
	})]
});
export default SvgMoreVert;
